import { render, staticRenderFns } from "./insuranceCriticismManagement.vue?vue&type=template&id=35547aa9&"
import script from "./insuranceCriticismManagement.vue?vue&type=script&lang=js&"
export * from "./insuranceCriticismManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports